import React, { useEffect, useState } from "react";
import MainStore from "../stores/MainStore";
import ItemHolder from "./ItemHolder";

const CatSelector = ({ selectedBoxType, setSelectedBoxType }) => {
  const [expanded, setExpanded] = useState(false);
  const [cats, setCats] = useState([]);
  const { player } = MainStore();

  useEffect(() => {
    if (player) {
      setCats(["all", ...Object.keys(player.boxTypes)]);
    }
  }, [player]);

  function clickCat(cat) {
    setSelectedBoxType(cat);
    setExpanded(false);
  }
  return (
    <div
      style={{ position: "absolute", right: "0px", height: "100%", zIndex: 1 }}
    >
      {!expanded && (
        <ItemHolder
          onClick={() => setExpanded(true)}
          item={{ key: selectedBoxType }}
        />
      )}
      {expanded &&
        cats.map((c) => <ItemHolder onClick={clickCat} item={{ key: c }} />)}
    </div>
  );
};

export default CatSelector;
